import Callout from 'components/_core/Callout';

import locales from './locales';

const MissingAccountHolderMessage = () => (
  <Callout variant="error">
    <Callout.Title>{locales.title}</Callout.Title>
    <Callout.Content>{locales.description}</Callout.Content>
  </Callout>
);

export default MissingAccountHolderMessage;
